import React from 'react';

function AccountList({ accounts, setAccounts, trades, setTrades }) {
  const handleDelete = (accountName) => {
    if (window.confirm('确定要删除该账户吗？相关交易记录也会被删除。')) {
      setAccounts(accounts.filter(acc => acc.name !== accountName));
      setTrades(trades.filter(trade => trade.account !== accountName));
    }
  };

  return (
    <div className="section">
      <h2>账户列表</h2>
      <table>
        <thead>
          <tr><th>名称</th><th>市场</th><th>本金</th><th>操作</th></tr>
        </thead>
        <tbody>
          {accounts.length === 0 ? (
            <tr><td colSpan="4">暂无账户</td></tr>
          ) : (
            accounts.map(account => (
              <tr key={account.name}>
                <td>{account.name}</td>
                <td>{account.market}</td>
                <td>{account.currency}{account.capital}</td>
                <td><button onClick={() => handleDelete(account.name)}>删除</button></td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default AccountList; 